import React from "react";
import cx from "classnames";
import {EModalMode} from "@components/elements/EModalMode";
import {Modal} from "@components/elements/Modal";
import {Overlay} from "@components/elements/Overlay";

export function FiltersModal(props: {
    onClose: () => void, className?: string, onResetFilters: () => void, children: React.ReactNode
    isOpen: boolean
}) {
    return (<Overlay
        fullScreen={true}
        className={cx("bg-gray-900 dark:bg-gray-900 bg-opacity-50 dark:bg-opacity-50", (!props.isOpen && "hidden"),)}>
        <Modal
            type={EModalMode.MAX_SIZE}
            onClose={props.onClose}
        >
            {props.children}
        </Modal>
    </Overlay>);
}